import api from "./api";
import {
	EmailModel,
	PasswordSetModel,
	PhoneNumberModel,
	PhoneVerificationModel,
	SmsEmailVerifyModel,
	TokenModel,
} from "../shared/models/Verification.model";
import { AxiosResponse } from "axios";

const smsSendApi = async (phoneNumber: PhoneNumberModel): Promise<AxiosResponse> => {
	return await api.post(`${process.env.REACT_APP_BACKEND_API}/password-reset/sms-send`, phoneNumber);
};

const smsVerifyApi = async (smsVerifyData: PhoneVerificationModel): Promise<AxiosResponse> => {
	return await api.post(`${process.env.REACT_APP_BACKEND_API}/password-reset/sms-verify`, smsVerifyData);
};

const smsEmailVerifyApi = async (smsEmailVerifyData: SmsEmailVerifyModel): Promise<AxiosResponse> => {
	return await api.post(`${process.env.REACT_APP_BACKEND_API}/password-reset/sms-email-verify`, smsEmailVerifyData);
};

const emailSendApi = async (email: EmailModel): Promise<AxiosResponse> => {
	return await api.post(`${process.env.REACT_APP_BACKEND_API}/password-reset/email-send`, email);
};

const emailVerifyApi = async (token: TokenModel): Promise<AxiosResponse> => {
	return await api.post(`${process.env.REACT_APP_BACKEND_API}/password-reset/email-verify`, token);
};

const newPasswordSetApi = async (passwordSetData: PasswordSetModel): Promise<AxiosResponse> => {
	return await api.put(`${process.env.REACT_APP_BACKEND_API}/password-reset/new-password-set`, passwordSetData);
};

export { smsSendApi, emailVerifyApi, emailSendApi, smsVerifyApi, smsEmailVerifyApi, newPasswordSetApi };
